<template>
  <v-app class="page">
    <v-container fluid class="fill-height pa-0">
      <v-row class="fill-height">
        <!-- LEFT: Login Form -->
        <v-col
          cols="12"
          md="12"
          class="d-flex justify-center align-center pa-0"
        >
          <v-card class="pa-6" width="100%" max-width="500" flat>
            <!-- Logo -->
            <v-row justify="center" class="mb-6">
              <img :src="logo" height="80" contain />
            </v-row>
            <v-row justify="center" class="px-2 mb-6 text-center justify-cente">
              <v-alert
                type="error"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
                icon="mdi-alert-outline"
              >
                {{ $t("reset_password_text") }}
              </v-alert>
            </v-row>
            <!-- Form -->
            <v-form @submit.prevent="sendReset">
              <v-text-field
                v-model="reset_email"
                label="Email"
                type="email"
                prepend-inner-icon="mdi-email"
                required
                variant="solo"
                persistent-placeholder
              />

              <!-- <v-select
                v-model="language"
                :items="selectLanguage"
                item-title="lang"
                item-value="locale"
                label="Select Language"
                variant="solo"
                prepend-inner-icon="mdi-web"
                dense
              /> -->

              <!-- Alerts -->
              <v-alert
                v-if="alert.value"
                type="warning"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert.message }}
              </v-alert>

              <v-alert
                v-if="alert_s.value"
                type="success"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert_s.message }}
              </v-alert>

              <!-- Login Button -->
              <v-row justify="center" class="mt-4">
                <v-btn
                  :loading="loading"
                  color="red-darken-4"
                  dark
                  type="submit"
                  :disabled="!reset_email"
                  class="w-100"
                >
                  {{ $t("reset_password") }}
                  <v-icon end class="mx-1">mdi-send-check-outline</v-icon>
                </v-btn>
              </v-row>
            </v-form>
          </v-card>
        </v-col>

        <!-- RIGHT: Background image, only for md+ screens -->
        <!-- <v-col cols="12" md="3" class="d-none d-md-flex pa-0">
          <div
            class="bg-image"
            :style="{ backgroundImage: `url(${bgImage})` }"
          ></div>
        </v-col> -->
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import determineIpLocation from "../utils/determineIpLocation";
import logoImg from "@/assets/logo_dark.png";
import bg from "@/assets/login_background0.png";
import postRequest from "../api/postRequest";

export default {
  name: "Login",
  data() {
    return {
      logo: logoImg,
      bgImage: bg,
      showPassword: false,
      login: {
        email: "",
        password: "",
      },
      language: "it",
      selectLanguage: [
        { lang: "Italiano", locale: "it" },
        { lang: "English", locale: "en" },
      ],
      alert: { value: false, message: "" },
      alert_s: { value: false, message: "" },
      loading: false,
      reset_email: null,
    };
  },
  watch: {},

  mounted() {},
  created() {
    this.$i18n.locale = "it";
    this.setLanguage();
  },
  methods: {
    async sendReset() {
      if (!this.reset_email) return;
      this.loading = true;
      postRequest
        .object("/user/forgot-password", {
          email: this.reset_email,
        })
        .then((res) => {
          if (res.data.success === true) {
            this.loading = false;
            setTimeout(() => {
              this.$router.push({ path: "/auth" });
            }, 5000);
          } else {
            this.loading = false;
            this.alert.value = true;
            this.alert.message = res.data.message;
            setTimeout(() => {
              this.alert.value = false;
              this.$router.push({ path: "/auth" });
            }, 3000);
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;
            this.alert.value = true;
            this.alert.message =
              err.response.data.message || "Something went wrong";
            setTimeout(() => {
              this.alert.value = false;
            }, 4000);
          }
        });
    },
    setLanguage() {
      determineIpLocation()
        .then((response) => {
          const { country } = response;
          switch (country) {
            case "IT":
              this.language = "it";
              break;
            default:
              this.language = "it";
              break;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.page {
  min-height: 100vh;
}

.bg-image {
  background-size: cover;
  background-position: center center;
  flex: 1;
}
</style>
